export const TabletLandscapeWidth = 1024;
export const TabletWidth = 768;
export const LaptopWidth = 1024;
export const DesktopWidth = 1440;